import React, { useEffect, useMemo, useState } from 'react';
import { I18nContext } from './i18nContext.js';
import { TRANSLATIONS } from './i18n.messages.js';

export function I18nProvider({ children }) {
	const [lang, setLang] = useState(() => localStorage.getItem('lang') || 'en');

			useEffect(() => {
				try {
					localStorage.setItem('lang', lang);
				} catch {
					// ignore write errors (private mode, quota, etc.)
				}
		// also update document language attribute for accessibility
		if (typeof document !== 'undefined') {
			document.documentElement.lang = lang;
		}
	}, [lang]);

	const value = useMemo(() => ({
		lang,
		setLang,
		t: (key) => {
			const dict = TRANSLATIONS[lang] || TRANSLATIONS.en;
			return dict[key] ?? key;
		}
	}), [lang]);

	return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

